var map = {
	"./alert-error.svg": 2939,
	"./alert-success.svg": 8970,
	"./arrow-down.svg": 4746,
	"./arrow-right-blue.svg": 5823,
	"./arrow-right-red.svg": 9461,
	"./arrow-right.svg": 153,
	"./calendar.svg": 874,
	"./check-double.svg": 887,
	"./check-mark-white.svg": 3302,
	"./check-single.svg": 7028,
	"./check.svg": 706,
	"./chevron-down.svg": 1728,
	"./close.svg": 420,
	"./cross-white.svg": 6510,
	"./cross.svg": 7093,
	"./dormitory-status-accept.svg": 5140,
	"./dormitory-status-process.svg": 1542,
	"./dormitory-status-reject.svg": 5304,
	"./dormitory-status-verification.svg": 5278,
	"./dropzone-file.svg": 6765,
	"./dropzone-image.svg": 3755,
	"./dropzone-video.svg": 1871,
	"./error-outline.svg": 7102,
	"./eye-off.svg": 2010,
	"./eye-on.svg": 1712,
	"./eye-x.svg": 3794,
	"./header-menu-my-campuses.svg": 2370,
	"./header-menu-notifications.svg": 2814,
	"./header-menu-organization-data.svg": 7319,
	"./header-menu-security.svg": 6670,
	"./heart-green.svg": 3247,
	"./heart-selected.svg": 2984,
	"./heart-unselected.svg": 4685,
	"./info.svg": 7292,
	"./map-icon.svg": 8488,
	"./map-pointer.svg": 7515,
	"./mapping-arrow.svg": 6004,
	"./more-vert.svg": 238,
	"./navbar-notifications.svg": 6385,
	"./navbar-profile.svg": 1654,
	"./notification-danger.svg": 5364,
	"./notification-info.svg": 5878,
	"./notification-warning.svg": 4983,
	"./photo-cros.svg": 5701,
	"./record-delete.svg": 3398,
	"./record-edit.svg": 4734,
	"./select-arrow.svg": 6009,
	"./spinning-arrows.svg": 4631,
	"./star-selected.svg": 674,
	"./star-unselected.svg": 988,
	"./trash-can.svg": 536
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7254;